/** Primary CTAs in ability / test flows — theme tokens for light/dark. */

export const testBtnPrimary =
  'px-6 py-2.5 bg-primary text-primary-foreground rounded-full hover:bg-primary-hover focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:ring-offset-canvas transition-colors font-medium text-sm';

export const testBtnPrimaryLg =
  'px-6 py-3 bg-primary text-primary-foreground rounded-full hover:bg-primary-hover focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:ring-offset-canvas transition-colors font-semibold text-sm';

export const testBtnSecondary =
  'px-6 py-2.5 bg-surface-muted text-ink rounded-full border border-edge hover:bg-edge transition-colors font-medium text-sm';

export const testBtnOutline =
  'px-4 py-2 text-sm font-semibold rounded-full border border-edge-strong text-ink-muted bg-surface hover:bg-surface-muted hover:text-link-hover hover:border-link/40 transition-colors';

export const testBtnDisabled =
  'px-5 py-2.5 rounded-full bg-surface-muted text-ink-subtle cursor-not-allowed text-sm font-medium';

export const testLink =
  'text-sm font-medium text-link hover:text-link-hover transition-colors';

export const testProgressTrack = 'flex-1 h-2.5 bg-edge rounded-full overflow-hidden min-w-[80px]';

export const testProgressFill = 'h-full bg-primary rounded-full transition-all duration-300';

export const testFocusRing =
  'focus:outline-none focus-visible:ring-4 focus-visible:ring-ring/40 focus-visible:ring-offset-2 focus-visible:ring-offset-canvas';

export const testSectionCard =
  'relative flex flex-col justify-between rounded-lg border border-edge bg-surface-muted p-5 md:p-6 text-left text-ink shadow-sm hover:bg-surface hover:border-edge-strong transition-colors';

/** Timer chip — readable in both themes */
export const testTimerOk =
  'bg-surface-muted text-ink border border-edge';

export const testTimerUrgent =
  'bg-red-50 text-red-700 border border-red-200 dark:bg-red-950/50 dark:text-red-200 dark:border-red-800/60';
